<template>
    <l-marker
        :lat-lng="forceLatlng || [device.posY, device.posX]"
        @click="goToDeviceView"
    >
        <l-icon :icon-anchor="isCompact ? [6, 6] : [14, 13]">
            <div :style="style">
                <div
                    v-if="device.isEmitting"
                    class="circle"
                    :style="{animationDelay: animationDelay + 's'}"
                />
                <div
                    v-if="device.isEmitting"
                    class="circle2"
                    :style="{animationDelay: animationDelay + 0.2 + 's'}"
                />

                <div v-if="isCompact" class="scheme-marker">
                    <div
                        :style="{backgroundImage: 'url(' + deviceIconUrl + ')'}"
                        style="height: 14px; width: 14px; background-size: contain;"
                    />
                </div>

                <div v-if="!isCompact" class="scheme-marker">
                    <div
                        :style="{backgroundImage: 'url(' + deviceIconUrl + ')'}"
                        style="height: 28px; width: 28px; flex: 0 0 auto;"
                    />
                    <div v-if="showNames" style="font-size: 18px; line-height: 28px; white-space: nowrap;">
                        {{ device.name }}
                    </div>
                </div>
            </div>
        </l-icon>

        <l-tooltip :options="{offset: isCompact ? [0, -6] : [0, -12], direction: 'top'}">
            <div class="device-map-tooltip">
                <div class="text-h6">{{ device.name }}</div>
                <div class="text-caption">Группа: {{ device.group?.name }}</div>
                <div class="device-tooltip-state">{{ device.stateLabel }}</div>
                <div v-if="device.lastPowerPacket" class="device-tooltip-extra text--secondary">
                    <span>{{ device.lastPowerPacket.power }} Вт</span>
                    <span>{{ displayAgo(device.lastPowerPacket.processedAt) }}</span>
                </div>
                <div v-if="device.lastDetectorPacket" class="device-tooltip-extra text--secondary">
                    <span>{{ displayAgo(device.lastDetectorPacket.processedAt) }}</span>
                </div>
            </div>
        </l-tooltip>
    </l-marker>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'
import {Device, getDeviceIconUrl} from '@/models/Device'
import {displayAgo} from '@/utils/datetime'

@Component
export default class DeviceMarker extends Vue
{
    @Prop({type: Object, required: true})
    device!: Device

    @Prop({type: Boolean, default: false})
    isCompact!: boolean

    @Prop({type: Boolean, default: false})
    showNames!: boolean

    @Prop({type: Number, default: 0})
    animationDelay!: number

    @Prop({type: Array})
    forceLatlng?: [number, number]

    @Prop({type: Number})
    offset?: number

    displayAgo = displayAgo

    get deviceIconUrl() {
        return getDeviceIconUrl(this.device)
    }

    goToDeviceView() {
        this.$router.push(`/devices/view/${this.device.id}`)
    }

    get style(): Record<string, never> | {position: 'relative', top: string}  {
        if (!this.offset) {
            return {}
        }
        return {
            position: 'relative',
            top: (-this.offset * 19) + 'px',
        }
    }
}
</script>
